import {LOAD_BAR} from '../../constants/loadBar';
import {CNPJ_TYPES} from '../../constants/typesMessages';
import {removeMask, removeMaskCnpj} from '../../utils';

import {notInfoInBureau} from './establishmentMessages';

/**
 * Starts the first stage of the CHAT flow
 * EC informs CNPJ
 */
export const informCNPJRequest = (response) => {
  let responseCnpj = [];
  responseCnpj = notInfoInBureau(response.data);
  return responseCnpj;
};

/**
 * Validates CNPJ imputed to continue
 */
export const informCNPJ = (inputValue) => {
  const valueMessage = removeMaskCnpj(inputValue);
  if (valueMessage.length !== 14) {
    return {
      status: false,
      messages: [
        {
          text: 'Por favor, informe um CNPJ válido com 14 caracteres.',
          type: 'message-receive'
        }
      ]
    };
  }

  return {
    status: true,
    value: valueMessage,
    messages: [
      {
        text: inputValue,
        edit: CNPJ_TYPES.CNPJ_FLOW,
        type: CNPJ_TYPES.CNPJ
      }
    ]
  };
};

/**
 * EC informs CNAE to validate
 * if EC can enable products
 */

/**
 * When it comes without data in the Bureau
 */
export const informCNAERequest = (ecBasicData, cnae) => {
  return {
    chatStageFlow: LOAD_BAR.CNAE,
    value: cnae,
    ec: ecBasicData
  };
};

/**
 * Validates CNAE charged to continue
 */
export const informCNAE = (ecState, inputValue) => {
  const valueMessage = removeMask(inputValue);
  if (valueMessage.length !== 7) return {status: false};

  return {
    status: true,
    value: valueMessage,
    newEc: {
      ...ecState.ecBasicData,
      primaryCnae: valueMessage
    },
    messages: [
      {
        text: inputValue,
        edit: 'informations-cnpj-cnae',
        type: 'response-sent'
      }
    ]
  };
};

/**
 * Ec needs to complete this data if none
 * in Bero
 */
export const informLegalName = (ecState, inputValue) => ({
  messages: [
    {
      text: inputValue,
      edit: 'informations-cnpj-legal-name',
      type: 'response-sent'
    },
    {
      text: 'E o Nome Fantasia?',
      type: 'message-receive'
    }
  ],
  newEc: {
    ...ecState,
    ecBasicData: {...ecState.ecBasicData, legalName: inputValue.trim()}
  },
  responseType: 'informations-cnpj-fantasy-name'
});

/**
 * Ec needs to complete these data if they do not exist in the Bureau
 */
export const informFantasyName = (ecState, inputValue) => ({
  messages: [
    {
      text: inputValue,
      edit: 'informations-cnpj-fantasy-name',
      type: 'response-sent'
    },
    {
      text: 'Agora, me informe o CNAE, por favor. O CNAE precisa ser aderente aos produtos Alelo, não necessariamente precisa ser o CNAE primário da Receita Federal.',
      type: 'message-receive'
    }
  ],
  newEc: {
    ...ecState,
    ecBasicData: {...ecState.ecBasicData, fantasyName: inputValue.trim()}
  },
  responseType: 'informations-cnpj-cnae'
});

/**
 * Editing functionality still needs to be defined and refined
 */
export const resetChatToEditCnpj = (messages, cnpj, messageEdit) => {
  // filter searching for the first CNPJ inserção and resetting the chat part of it ...
  let messagesUpdate = messages.filter((msg) => msg.id < messageEdit.id);
  messagesUpdate.push({
    id: messagesUpdate.length + 1,
    text: cnpj,
    edit: CNPJ_TYPES.CNPJ_FLOW,
    type: CNPJ_TYPES.CNPJ
  });
  return messagesUpdate;
};
